<div class="input-container">
    <label class="input-label" [ngClass]="disabled?'input-label-disabled': 'input-label'" >{{labelText}}</label>
    <textarea class="input textarea" appTextAreaGrow (ngModelChange)="textChange()" [(ngModel)]="textModel" *ngIf="type == 'textarea'"
        [placeholder]="placeholder" [required]="required" [ngClass]="{'input__invalid': !validate()}" (ngModelChange)="onChange($event)" >
    </textarea>
    <input class="input"  [ngClass]="disabled?'input-disabled': 'input'" [disabled]="disabled" [type]="type" [(ngModel)]="textModel" *ngIf="type != 'textarea'" (ngModelChange)="textChange()"
        [placeholder]="placeholder" [required]="required" [ngClass]="{'input__invalid': !validate()}" (ngModelChange)="onChange($event)" >
    <mat-icon *ngIf="!validate()" class="input--icon">warning</mat-icon>
    <label class="warning-label" *ngIf="submitted && warningLabel && !validate()">{{warningLabel}}</label>
</div>
 